import fetcher from './fetcher';

const fetcherWithDataKey =
  <T>(key: string) =>
  async (path: string, options = {}) => {
    const data = await fetcher<{ [k: typeof key]: T }>(path, options);
    return data?.[key];
  };

export default fetcherWithDataKey;
